import { cloneDeep } from 'lodash';
import { ShareNumbers } from './sharenumber-classes';

// We should sell oldest shares first.

// Provide essential defaults etc to avoid too much checking in operations.
// Provide a stamp if not set.
// order the array by stamp.
export function santizeShareNumbers(numbers: ShareNumbers[]) {
  if (numbers && numbers.length > 0) {
    for (const x of numbers) {
      if (!x.timeStamp) {
        x.timeStamp = 0;
      }
    }
    numbers.sort(shareStampCompare);
  }
}

export function shareStampCompare(a: ShareNumbers, b: ShareNumbers) {
  if (a.timeStamp < b.timeStamp) return 1;
  if (a.timeStamp > b.timeStamp) return -1;
  // if (a.from < b.from) return 1;
  // if (a.from > b.from) return -1;
  return 0;
}

export function cloneShareNumbersArray(x: ShareNumbers[]) {
  const y = cloneDeep(x);
  return y;
}

export function cloneShareNumbers(x: ShareNumbers) {
  const y = cloneDeep(x);
  return y;
}
